import _ from 'underscore'

import AlertGuideIcon from '@mui/icons-material/WarningAmberOutlined'
import BookmarkIcon from 'components/SideNavbar/BookmarkIcon'
import CustomersIcon from '@mui/icons-material/PeopleAltOutlined'
import DashboardIcon from '@mui/icons-material/HomeOutlined'
import DealersIcon from '@mui/icons-material/PeopleOutlined'
import DeviceAggregatorIcon from '@mui/icons-material/DeviceHubOutlined'
import DeviceMetricsIcon from '@mui/icons-material/HealthAndSafetyOutlined'
import DeviceSearchIcon from '@mui/icons-material/SearchOutlined'
import NotificationsIcon from '@mui/icons-material/SettingsOutlined'
import ResourcesIcon from '@mui/icons-material/HelpOutline'
import SiteMessagesIcon from '@mui/icons-material/MessageOutlined'
import UpdatesIcon from '@mui/icons-material/NotificationImportantOutlined'
import WarrantyLookupIcon from '@mui/icons-material/GppGoodOutlined'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import PmkLogoIcon from 'components/SideNavbar/PmkLogoIcon'
import ChatbotIcon from 'components/SideNavbar/ChatbotIcon'

const ALERT_GUIDE_LINK = { text: 'Alert Lookup', href: '/alerts', appTentiveId: 'alert_lookup_nav_selected', icon: AlertGuideIcon }
const DEVICE_AGGREGATOR_LINK = { text: 'Device Aggregator', href: '/device_aggregator', appTentiveId: 'aggregator_nav_selected', icon: DeviceAggregatorIcon }
const DEVICE_SEARCH_LINK = { text: 'Device Search', href: '/devices', activeForPaths: [/^\/devices/, /^\/admin\/device/], appTentiveId: 'device_search_nav_selected', icon: DeviceSearchIcon }
const FAVORITES_LIST_LINK = { text: 'Favorites', href: '/favorites', appTentiveId: 'favorites_list_nav_selected', icon: BookmarkIcon }
const RESOURCES_LINK = { text: 'Resources', href: '/resources/field-tech-help', activeForPaths: [/^\/resources/], icon: ResourcesIcon }
const RESOURCES_ADMIN_LINK = { text: 'Resources', href: '/admin/resources/field-tech-help', activeForPaths: [/^\/admin\/resources/], icon: ResourcesIcon }
const UPDATES_LINK = { text: 'Updates', href: '/updates/current', activeForPaths: [/^\/updates/], appTentiveId: 'updates_nav_selected', icon: UpdatesIcon }
const WARRANTY_LOOKUP_LINK = { text: 'Warranty Lookup', href: '/warranty_lookup', appTentiveId: 'warranty_lookup_nav_selected', icon: WarrantyLookupIcon }
const TECH_ASSISTANT_LINK = { text: 'Tech Assistant', href: '/tech_assistant', appTentiveId: 'tech_assistant_nav_selected', icon: ChatbotIcon }

export const LINKS_BY_ROLE = {
  admin: [
    DEVICE_SEARCH_LINK,
    FAVORITES_LIST_LINK,
    { text: 'Dealers', href: '/admin/dealers', icon: DealersIcon },
    ALERT_GUIDE_LINK,
    { text: 'Site Messages', href: '/admin/site_messages', icon: SiteMessagesIcon },
    DEVICE_AGGREGATOR_LINK,
    { text: 'Notifications', href: '/admin/alert_notification_configurations', icon: NotificationsIcon },
    { text: 'Maintenance Trends', href: '/admin/metrics', icon: DeviceMetricsIcon },
    RESOURCES_ADMIN_LINK,
    WARRANTY_LOOKUP_LINK,
    { text: 'Features', href: '/admin/features', icon: WorkspacePremiumIcon },
    { text: 'EHMKT', href: '/admin/hehm', icon: PmkLogoIcon },
    TECH_ASSISTANT_LINK
  ],
  dealer: [
    { text: 'Dashboard', href: '/dashboard', appTentiveId: 'dashboard_nav_selected', icon: DashboardIcon },
    { text: 'Customers', href: '/customers', activeForPaths: [/^\/archived_devices/, /^\/customers(?!\/new)/, /^\/unassigned/], appTentiveId: 'customers_nav_selected', icon: CustomersIcon },
    ALERT_GUIDE_LINK,
    UPDATES_LINK,
    { text: 'Notifications', href: '/notifications', appTentiveId: 'notifications_nav_selected', icon: NotificationsIcon },
    DEVICE_AGGREGATOR_LINK,
    RESOURCES_LINK,
    WARRANTY_LOOKUP_LINK,
    TECH_ASSISTANT_LINK
  ],
  fsr: [
    DEVICE_SEARCH_LINK,
    FAVORITES_LIST_LINK,
    UPDATES_LINK,
    ALERT_GUIDE_LINK,
    DEVICE_AGGREGATOR_LINK,
    RESOURCES_LINK,
    WARRANTY_LOOKUP_LINK,
    TECH_ASSISTANT_LINK
  ],
  technician: [
    DEVICE_SEARCH_LINK,
    FAVORITES_LIST_LINK,
    UPDATES_LINK,
    ALERT_GUIDE_LINK,
    DEVICE_AGGREGATOR_LINK,
    RESOURCES_LINK,
    WARRANTY_LOOKUP_LINK,
    TECH_ASSISTANT_LINK
  ],
  unknown: []
}

const findActiveNavbarLink = (role, pathname) => {
  return _.find(LINKS_BY_ROLE[role], (link) => {
    const pattern = /metrics/
    if (pattern.test(pathname)) {
      return pattern.test(link.href)
    } else if (/feature_tours/.test(pathname)) {
      return /site_messages/.test(link.href)
    } else {
      const activeForPaths = pattern.test(pathname) && pattern.test(link) ? new RegExp('^' + link.href) : _.flatten([link.activeForPaths || new RegExp('^' + link.href)])
      return _.any(activeForPaths, (activeForPath) => pathname.match(activeForPath))
    }
  })
}

export default findActiveNavbarLink
